import { Component, OnInit } from '@angular/core';
import {TransactionService} from '../transaction.service';
import {PhysicianService} from '../../physician/service/physician.service';
import {PatientService} from '../../patient/service/patient.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {AppointmentService} from '../../appointment/appointment.service';

@Component({
  selector: 'app-view-transaction',
  templateUrl: './view-transaction.component.html',
  styleUrls: ['./view-transaction.component.css']
})
export class ViewTransactionComponent implements OnInit {
    itemsPerPage = 20;
    currentPage = 1;
    numberOfTransactions:any;
    byPhysician:boolean = false;
    byPatient:boolean = false;
    byAppointment:boolean = false;
    byAllTransaction:boolean = true;
    transactionList = [];
    physicianList = [];
    patientList = [];
    appointmentList = [];
    searchPhyTerm : FormControl = new FormControl();
    searchPatientTerm : FormControl = new FormControl();
    status = '';
    regExp = '';
    myDateValue: Date;
    //minDate:Date;
    //maxDate:Date;
    selectedPhysicianUserId:any;
    selectedPatientUserId:any;
    filterChoose = 'all';
    keyword = 'physicianName';
    keywordPatient = 'formattedName';
    keywordAppointment = 'appointmentNumber';
    bsValue = new Date();
    bsRangeValue: Date[];
    fromDate = new Date();
    toDate = new Date();
    public loading = true;
    public loadingPhysician = false;
    viewTransactionFilterForm: FormGroup;

    constructor(private _formBuilder: FormBuilder,
                private transactionService:TransactionService,
                private appointmentService:AppointmentService,
                private datepipe: DatePipe,
                private physicianService:PhysicianService,
                private patientService:PatientService) {

        this.fromDate.setDate(this.fromDate.getDate() - 7);
        this.toDate.setDate(this.toDate.getDate() - 1);
        this.bsRangeValue = [this.fromDate, this.bsValue ];

        this.viewTransactionFilterForm = this. _formBuilder.group({
            filterChoose: ['', Validators.required],
            searchPhyId: [''],
            searchUserId: [''],
            searchPatientId: [''],
            searchAppointmentId: [''],
            fromDate: [this.fromDate , Validators.required],
            toDate: [this.toDate, Validators.required]
        });

    }

  ngOnInit() {
      this.getAllTransactions();
      this.searchPhyTerm.valueChanges.subscribe(value => {
          if(value != ''){
              this.getAllPhysician(value);
          } else if(value === '') {
              this.getAllPhysician('')
          }
      })

      this.searchPatientTerm.valueChanges.subscribe(value => {
          if(value != ''){
              this.getAllPatients(value);
          } else if(value === '') {
              this.getAllPatients('')
          }
      })
      //this.getAllPhysician();
  }

    private getAllTransactions() {
        this.loading = true;
        this.transactionList = [];
        this.transactionService.getAllTransactions(this.currentPage - 1, status, this.itemsPerPage, '')
            .subscribe(data => {
                const response: any = data.json();
                this.transactionList = response.transactions;
                this.numberOfTransactions = response.numberOfTransactions;
                console.log(this.transactionList);

                this.loading = false;
            }, (error) => {
                this.loading = false;
                // this.toastr.error('', 'Please try again');
            });
    }

    private getAllPhysician(term) {
        this.loadingPhysician = true;
        this.physicianList = [];
        this.physicianService.getAllPhysicians(0,'',999, term)
            .subscribe(data => {
                const response: any = data.json();
                this.physicianList = response.physicians;
                this.loadingPhysician = false;
            }, (error) => {
                this.loading = false;
                // this.toastr.error('', 'Please try again');
            });
    }

    search() {

        console.log(this.viewTransactionFilterForm);

        if(this.viewTransactionFilterForm.get('filterChoose').value === 'phy' ||
            this.viewTransactionFilterForm.get('filterChoose').value === 'patient' ){

            this.getPhysicianList(this.viewTransactionFilterForm.get('searchUserId').value,
                this.datepipe.transform(this.viewTransactionFilterForm.get('fromDate').value, 'yyyy-MM-ddT00:00:00ZZZZZ'),
                this.datepipe.transform(this.viewTransactionFilterForm.get('toDate').value, 'yyyy-MM-ddT23:59:59ZZZZZ'));
        } else {
            this.getTransactionByAppointmentNumberList(this.viewTransactionFilterForm.get('searchAppointmentId').value);
        }


/*
        if(this.viewTransactionFilterForm.get('filterChoose').value === 'phy'){
            this.getPhysicianList(this.viewTransactionFilterForm.get('searchUserId').value,
                this.datepipe.transform(this.viewTransactionFilterForm.get('fromDate').value, 'yyyy-MM-ddT00:00:00ZZZZZ'),
                this.datepipe.transform(this.viewTransactionFilterForm.get('toDate').value, 'yyyy-MM-ddT23:59:59ZZZZZ'))
        }

        if(this.viewTransactionFilterForm.get('filterChoose').value === 'patient'){
            this.getPhysicianList(this.viewTransactionFilterForm.get('searchUserId').value,
                this.datepipe.transform(this.viewTransactionFilterForm.get('fromDate').value, 'yyyy-MM-ddT00:00:00ZZZZZ'),
                this.datepipe.transform(this.viewTransactionFilterForm.get('toDate').value, 'yyyy-MM-ddT23:59:59ZZZZZ'))
        }
*/

        /*if(this.byPhysician) {
            console.log(this.toDate);
            console.log(this.fromDate);
        } else if(this.byPatient) {

        }*/

    }

    private getAllPatients(term) {
        this.loadingPhysician = true;
        this.patientList = [];
        this.patientService.getAllPatients(0,'',999,term)
            .subscribe(data => {
                const response: any = data.json();
                this.patientList = response.patients;
                this.loadingPhysician = false;
            }, (error) => {
                this.loading = false;
                // this.toastr.error('', 'Please try again');
            });
    }

    private getAllAppointments(term) {
        this.loadingPhysician = true;
        this.appointmentList = [];
        this.appointmentService.getAllAppointments(0,'',999,term)
            .subscribe(data => {
                const response: any = data.json();
                this.appointmentList = response.appointments;
                this.loadingPhysician = false;
            }, (error) => {
                this.loading = false;
                // this.toastr.error('', 'Please try again');
            });
    }

    pageChanged(event) {
        this.currentPage = event;
        if(this.viewTransactionFilterForm.get('filterChoose').value === 'phy' ||
            this.viewTransactionFilterForm.get('filterChoose').value === 'patient'){
            this.getPhysicianList(this.viewTransactionFilterForm.get('searchUserId').value,
                this.datepipe.transform(this.viewTransactionFilterForm.get('fromDate').value, 'yyyy-MM-ddT00:00:00ZZZZZ'),
                this.datepipe.transform(this.viewTransactionFilterForm.get('toDate').value, 'yyyy-MM-ddT23:59:59ZZZZZ'))
        } else {
            this.getAllTransactions();
        }
        console.log(event);
    }

    filterCheck() {
        this.filterChoose = this.viewTransactionFilterForm.get('filterChoose').value;
        console.log(this.filterChoose);

        if (this.filterChoose === 'phy') {
            //this.transactionList = [];
            this.byPhysician = true;
            this.byAppointment = false;
            this.byPatient = false;
            this.transactionList = [];
            this.currentPage=1;
            this.numberOfTransactions=0;
            //this.getAllPhysician('');
        } if (this.filterChoose === 'patient') {
            this.transactionList = [];
            this.numberOfTransactions=0;
            this.currentPage=1
            this.byPatient = true;
            this.byAppointment = false;
            this.byPhysician = false;

            //this.getAllPatients('');
        } if (this.filterChoose === 'appt') {
            this.transactionList = [];
            this.numberOfTransactions=0;
            this.byAppointment = true;
            this.byPhysician = false;
            this.byPatient = false;

        } if (this.filterChoose === 'all') {
            this.byAppointment = false;
            this.byPatient = false;

            this.numberOfTransactions=0;
            this.currentPage=1
            this.byPhysician = false;
            this.getAllTransactions();
        }
    }

    getPhysicianList(event, fromDate, toDate){
        console.log(event);
        if(event === null || event ===''){
            this.filterChoose = 'all';
            this.byAppointment = false;
            this.byPatient = false;
            this.byPhysician = false;
            this.getAllTransactions();
        } else {
            this.loading = true;
            this.transactionList = [];
            this.transactionService.getPhysicianTransactionByUserId(event,fromDate,toDate, this.currentPage -1, this.itemsPerPage).
            subscribe(data => {
                    const response: any = data.json();
                    this.transactionList = response.transactions;
                    this.numberOfTransactions = response.numberOfTransactions;
                    console.log(this.transactionList);

                    this.loading = false;
                    // TODO - Uncomment below code when using actual API
                    // const response: any = data;
                    // if (response.status === 200) {
                    //   this.userList = response.result;
                    // } else {
                    //   this.toastr.error('', 'Please try again');
                    // }
                }, (error) => {
                    this.loading = false;
                    console.log(error);
                    // this.toastr.error('', 'Please try again');
                });
        }

    }

    getTransactionByAppointmentNumberList(event){
        console.log(event);
        if(event === null || event ===''){
            this.filterChoose = 'all';
            this.byAppointment = false;
            this.byPatient = false;
            this.byPhysician = false;
            this.getAllTransactions();
        } else {
            this.loading = true;
            this.transactionList = [];
            this.transactionService.getTransactionByAppointmentNumber(event).
            subscribe(data => {
                    const response: any = data.json();
                    this.transactionList = response;
                    this.numberOfTransactions = this.transactionList.length;
                    console.log(this.transactionList);

                    this.loading = false;
                    // TODO - Uncomment below code when using actual API
                    // const response: any = data;
                    // if (response.status === 200) {
                    //   this.userList = response.result;
                    // } else {
                    //   this.toastr.error('', 'Please try again');
                    // }
                }, (error) => {
                    this.loading = false;
                    console.log(error);
                    // this.toastr.error('', 'Please try again');
                });
        }

    }

    displayPatientName(patient): string {
        return patient != null? patient.firstName + ' ' + patient.lastName : '';
    }

    displayPhyName(physician): string {
        return physician != null ? physician.physicianUser :''  ;
    }

    getPatientList(event){
        console.log(event);
        if(event === null || event === ''){
            this.filterChoose = 'all';
            this.byAppointment = false;
            this.byPatient = false;
            this.byPhysician = false;
            this.getAllTransactions();
        } else {
            this.loading = true;
            this.transactionList = [];
            this.transactionService.getTransactionByUserId(event.userId)
                .subscribe(data => {
                    const response: any = data.json();
                    this.transactionList = response.transactionHistory;
                    //this.numberOfTransactions = response.numberOfTransactions;
                    console.log(this.transactionList);

                    this.loading = false;
                    // TODO - Uncomment below code when using actual API
                    // const response: any = data;
                    // if (response.status === 200) {
                    //   this.userList = response.result;
                    // } else {
                    //   this.toastr.error('', 'Please try again');
                    // }
                }, (error) => {
                    this.loading = false;
                    // this.toastr.error('', 'Please try again');
                });
        }

    }

    selectEvent(item) {
        console.log(item);
        this.viewTransactionFilterForm.patchValue({searchUserId:item.userId});
        // do something with selected item
    }

    selectPatientEvent(item) {
        console.log(item);
        this.viewTransactionFilterForm.patchValue({searchUserId:item.userId});
        // do something with selected item
    }

    selectAppointmentEvent(item) {
        console.log(item);
        this.viewTransactionFilterForm.patchValue({searchAppointmentId:item.id});
        // do something with selected item
    }

}
